import { ApprovalRepository } from "../repositories/ApprovalRepository";

/**
 * Approve Review Use Case
 * Approves a review request
 */
export class ApproveReviewUseCase {
  constructor(private repository: ApprovalRepository) {}

  async execute(reviewId: number, comments?: string): Promise<void> {
    if (!reviewId || reviewId <= 0) {
      throw new Error("Valid review ID is required");
    }

    return await this.repository.approveReview(reviewId, comments);
  }
}
